import { Box, Button, Card, Container, Stack } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import Page from 'src/components/page/page';
import { paths } from 'src/routes/paths';
import { useHomeBanners } from './home-banners.hook';
import { useMyDataStore } from 'src/store/me/me.store';
import DataGridCustom from 'src/components/data-grid-custom';
import { HomeBannersTableToolbar } from './components/home-banners-table-toolbar';
import HomeBannersDrawerFilters from './components/home-banners-drawer-filters';
import ConfirmDeleteDialog from './components/confirm-delete-dialog';
import Iconify from 'src/components/iconify';

export default function HomeBanners() {
  const {
    isLoading,
    homeBannersTotal,
    homeBannersRows,
    gridSortModel,
    paginationModel,
    selectedRows,
    searchText,
    selectedFiltersCount,
    filters,
    homeBannersColumns,
    openFiltersDrawer,
    showDeleteButton,
    showConfirmDeleteDialog,
    navigate,
    handleSortModelChange,
    handleRowClick,
    handleFilterButtonClick,
    onRowSelectionModelChange,
    onHeaderSelectionCheckboxChange,
    setSearchText,
    setPaginationModel,
    setFilter,
    clearFilters,
    onCloseFilters,
    handleConfirmDelete
  } = useHomeBanners();

  const permissions = useMyDataStore((state) => state.me?.cnAdminInfo?.permissions?.personalization)

  const renderHomeBannersList = (
    <DataGridCustom
      animatedEachRow
      customFilters={
        <HomeBannersTableToolbar
          searchText={searchText}
          selectedFiltersCount={selectedFiltersCount}
          handleClickFilters={handleFilterButtonClick}
          setSearchText={setSearchText}
        />
      }
      excludeExportButton
      columns={homeBannersColumns}
      rows={homeBannersRows}
      totalRowsCount={homeBannersTotal}
      filteredRowsCount={homeBannersTotal}
      initialVisibleColumns={{}}
      sortModel={gridSortModel}
      paginationModel={paginationModel}
      pageSizeOptions={[5, 10, 20, 30, 40, 50]}
      isLoading={isLoading}
      onRowClick={handleRowClick}
      setSortModel={handleSortModelChange}
      setPaginationModel={setPaginationModel}
      rowSelectionModel={selectedRows}
      onRowSelectionModelChange={onRowSelectionModelChange}
      onHeaderSelectionCheckboxChange={onHeaderSelectionCheckboxChange}
      height={550}
    />
  );

  return (
    <Page title="Banners da Home">
      <Container maxWidth="xl">
        <HeaderBreadcrumbs links={[]} heading="Banners da Home" action={
          <Stack direction="row" spacing={2}>
            {
              showDeleteButton.value &&
              <Button
                size="small"
                variant="outlined"
                color='error'
                startIcon={<Iconify icon='lucide:trash-2' width={16} />}
                onClick={() =>
                  showConfirmDeleteDialog.onTrue()
                }
                disabled={!permissions?.delete}
                sx={{
                  animation: 'fadeIn 0.3s ease',
                  '@keyframes fadeIn': {
                    from: {
                      opacity: 0,
                    },
                    to: {
                      opacity: 1,
                    },
                  },
                }}
              >
                Excluir Banners
              </Button>
            }
            <Button
              size="small"
              variant="contained"
              startIcon={<Iconify icon='lucide:plus' width={16} />}
              onClick={() =>
                navigate(paths.dashboard.homeBannerCreate)
              }
              disabled={!permissions?.create}
            >
              Cadastrar Banner
            </Button>
          </Stack>
        } />
        <Card sx={{ px: 2, pt: 1, pb: 0, boxShadow: 4 }}>
          <Box height="100%">{renderHomeBannersList}</Box>
        </Card>
      </Container>
      <HomeBannersDrawerFilters
        isOpen={openFiltersDrawer}
        onClose={onCloseFilters}
        filters={filters}
        onApplyFilters={(nextFilters) => {
          Object.entries(nextFilters).forEach(([key, value]) => {
            setFilter(key as keyof typeof nextFilters, value as never);
          });
          onCloseFilters();
        }}
        onClearFilters={clearFilters}
      />
      <ConfirmDeleteDialog
        open={showConfirmDeleteDialog.value}
        onClose={showConfirmDeleteDialog.onFalse}
        onConfirm={handleConfirmDelete}
      />
    </Page>
  );
}
